import React from "react";
import { Box } from "@mui/material";
import { Routes, Route, useParams, useLocation } from "react-router-dom";

import { Sidebar } from "./components/sidebar/Sidebar";
import { Topbar } from "./components/topbar/Topbar";

import LoginPage from "./pages/auth/LoginPage";
import ResetPassPage from "./pages/auth/ResetPassPage";
import ForgotPassPage from "./pages/auth/ForgotPassPage";
import ApproveUserPage from "./pages/auth/ApproveUserPage";

import UserPage from "./pages/sidebar/UserPage";
import ExercisePage from "./pages/sidebar/ExercisePage";
import ConditionPage from "./pages/sidebar/ConditionPage";
import TreatmentPage from "./pages/sidebar/TreatmentPage";
import PhasePage from "./pages/sidebar/PhasePage";
import VideoPage from "./pages/sidebar/VideoPage";
import ProtocolPage from "./pages/sidebar/ProtocolPage";

import Dashboard from "./pages/Dashboard";

import ProfilePage from "./pages/topbar/ProfilePage";

import AuthGuard from "./guards/AuthGuard";

import "./index.css";
import PracticePage from "./pages/sidebar/PracticePage";
import CitationPage from "./pages/sidebar/CitationsPage";
import ReferralPage from "./pages/sidebar/ReferralPage";

const SectionPage = () => {
  const { section } = useParams();

  const pageMap = {
    practices: <PracticePage />,
    users: <UserPage />,
    exercises: <ExercisePage />,
    conditions: <ConditionPage />,
    treatments: <TreatmentPage />,
    citations: <CitationPage />,
    phases: <PhasePage />,
    videos: <VideoPage />,
    protocols: <ProtocolPage />,
    referrals: <ReferralPage />,
  };

  return pageMap[section];
};

export const MainRoute = () => {
  const location = useLocation();

  const excludedPages = [
    "/login",
    "/forgot_pass",
    "/reset_pass",
    "/approve_user/",
  ];

  const isExcludedPage = excludedPages.some((epage) =>
    location.pathname.startsWith(epage)
  );

  return (
    <Box display="flex" height="100vh">
      {!isExcludedPage && <Sidebar />}
      <Box
        flexGrow={1}
        display="flex"
        flexDirection="column"
        sx={{
          ml: isExcludedPage ? 0 : "270px",
        }}
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset_pass" element={<ResetPassPage />} />
          <Route path="/forgot_pass" element={<ForgotPassPage />} />
          <Route path="/approve_user/:username" element={<ApproveUserPage />} />
          <Route path="/referrals" element={<ReferralPage />} />
          <Route
            path="/:section"
            element={
              <>
                <AuthGuard>
                  <Topbar />
                  <SectionPage />
                </AuthGuard>
              </>
            }
          />
          <Route
            path="/"
            element={
              <AuthGuard>
                <Topbar />
                <Dashboard />
              </AuthGuard>
            }
          />
          <Route
            path="/profile"
            element={
              <>
                <AuthGuard>
                  <ProfilePage />
                </AuthGuard>
              </>
            }
          />
          <Route path="*" element={<h1>Page Not Found</h1>} />
        </Routes>
      </Box>
    </Box>
  );
};
